import {
  getMediaBasePath,
  IQuestionStatus,
  IQuestionStatusObject,
} from '@geneo2-web/shared-ui';
import { Subject_SubjectEnum } from '@protos/common/common.db_pb';
import { MultiSubjectSection } from '@protos/learning_management/lms.db_pb';
import { TeachClassSubjects } from '@protos/learning_management/lms.lesson.common.apis_pb';
import { SubjectList } from '@protos/user_management/ums.login.apis_pb';

const SubjectMap = {
  M: 'Mathematics',
  E: 'English',
  S: 'Science',
  SS: 'Social Science',
  SP: 'Physics',
  SC: 'Chemistry',
  SB: 'Biology',
  ELIT: 'English Literature',
  ELANG: 'English Language',
  EG: 'English Grammar',
  HIST: 'History',
  GEOG: 'Geography',
  ICT: 'Information and Communication Technology',
  EVS: 'Environmental Studies',
  CIV: 'Civics',
  ECO: 'Economics',
  GK: 'General Knowledge',
  BIZ: 'Business Studies',
  ACCT: 'Accountancy',
  STATS: 'Statistics',
  LR: 'Logical Reasoning',
  VOCAB: 'Vocabulary',
  GAME: 'Games',
  APT: 'Aptitude',
  GS: 'General Studies',
  LANG: 'Foreign Language',
  ENTMT: 'Entertainment',
  SBI_PO: 'SBI PO Exam',
  IBPS_PO: 'IBPS PO Exam',
  BANK_PO: 'Bank PO Exam',
  GOVT: 'Government Exams',
  URD: 'Urdu',
  H: 'Hindi',
  SANS: 'Sanskrit',
  MAR: 'Marathi',
  GUJ: 'Gujarati',
  SPL: 'Social and Political Life',
  PS: 'Political Science',
  TRAINING: 'Training',
  CL: 'Climate Leadership',
  ROBO: 'Robotics',
  COMP: 'Computer',
};
export const getSubjectNameFromEnum = (
  subjectEnum?: Subject_SubjectEnum
): string => {
  if (subjectEnum === undefined || subjectEnum === null) {
    return '';
  }
  if (subjectEnum === Subject_SubjectEnum.UNDEFINED) {
    return '';
  }
  const subjectKey = Object.keys(Subject_SubjectEnum).find(
    (key) =>
      Subject_SubjectEnum[key as keyof typeof Subject_SubjectEnum] ===
      subjectEnum
  );
  if (!subjectKey) return '';
  return SubjectMap[subjectKey as keyof typeof SubjectMap] ?? subjectKey;
};

// =============================================================

export const getSubjectImageBySubjectId = (
  subjectId?: number,
  classSubjects?: SubjectList[]
): string => {
  if (subjectId == null || !classSubjects?.length) return '';
  for (const subjectData of classSubjects ?? []) {
    if (subjectData.subjectId === subjectId && subjectData.iconUrl) {
      return getMediaBasePath(
        subjectData.iconUrl,
        'schoolnetStaticAssetBucket'
      );
    }
  }
  return '';
};

// =============================================================

export const getSubjectColorBySubjectId = (
  subjectId?: number,
  classSubjects?: SubjectList[]
): string => {
  if (subjectId == null || !classSubjects?.length) return '';
  for (const subjectData of classSubjects ?? []) {
    if (subjectData.subjectId === subjectId && subjectData.iconUrl) {
      return `${subjectData.textColor || '#000000'}33`;
    }
  }
  return '';
};

export interface ISummaryData {
  subject: string;
  attempted: number;
  total: number;
}

export const getSummaryData = (
  sections: MultiSubjectSection[],
  sectionRanges: { start: number; end: number }[],
  questionStatusArray: IQuestionStatusObject[]
): ISummaryData[] => {
  return sections.map((section, index) => {
    const range = sectionRanges[index];
    if (!range) {
      return {
        subject: getSubjectNameFromEnum(section.subject),
        attempted: 0,
        total: 0,
      };
    }
    const sectionQuestions = questionStatusArray.slice(range.start, range.end);
    const total = sectionQuestions.length;
    const attempted = sectionQuestions.filter(
      (q) =>
        q.statusInfo === IQuestionStatus.Attempted ||
        q.statusInfo === IQuestionStatus.Correct ||
        q.statusInfo === IQuestionStatus.Incorrect
    ).length;

    return {
      subject: getSubjectNameFromEnum(section.subject),
      attempted,
      total,
    };
  });
};
